import React from 'react';
import { Container, TwoCol, Wrapper } from 'src/components/Layout';
import { PageTitle } from 'src/components/Layout/PageTitle';
import { contact } from 'src/config';
import { RichText } from 'src/components/RichText/RichText';
import * as Accordion from '@radix-ui/react-accordion';
import { usePhoneNumber } from 'src/util/getPhoneNumber';

import { getCmsFaqMeta } from './content/CmsFaq';
import classes from './CmsFaqPage.scss';

type Props = Record<string, unknown>;

export const CmsFaqPage: React.FC<Props> = () => {
    const heroImage = require('../../../static/img/cms/faq-header.jpg');
    return (
        <>
            <section className={classes.hero} style={{ backgroundImage: `url(${heroImage})` }}>
                {' '}
            </section>
            <Wrapper variant="widget-wrapper">
                <Container>
                    <PageTitle title="Frequently Asked Questions" />
                    <TwoCol
                        main={
                            <div className={classes.content}>
                                <Content />
                            </div>
                        }
                        right={<Sidebar />}
                    />
                </Container>
            </Wrapper>
        </>
    );
};

function Content() {
    const phoneNumber = usePhoneNumber('spaced');
    const meta = getCmsFaqMeta({ phoneNumber });
    return (
        <Accordion.Root type="multiple" className="accordion">
            {meta.faqs.map((item) => {
                return (
                    <Accordion.Item key={item.title} value={item.title} className="accordion-item">
                        <Accordion.Header className="accordion-header">
                            <Accordion.Trigger className="accordion-trigger">{item.title}</Accordion.Trigger>
                        </Accordion.Header>
                        <Accordion.Content className="accordion-panel">
                            <RichText content={item.content} />
                        </Accordion.Content>
                    </Accordion.Item>
                );
            })}
        </Accordion.Root>
    );
}

function Sidebar() {
    const phoneNumber = usePhoneNumber('spaced');
    return (
        <div className={classes.sidebar}>
            <h2 className={classes.sidebarTitle}>Customer Services</h2>
            <p>
                We ensure your order is delivered to you promptly, safely and at low cost and as you'd expect, our
                customer service team are always on hand to answer any questions you may have.
            </p>
            <p className="h2">{phoneNumber}</p>
            <RichText content={contact.openingHours} />
        </div>
    );
}
